// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.__create__conteiner {
  display: block;
  font-size: 1.8rem;
  height: 100vh;
}

.create__row {
  box-shadow: 0px 4.8px 14.4px rgb(0 0 0 / 18%);
  border-radius: 4px;
  padding: 0.5rem 1rem 1rem 1rem;
  height: auto;
}

.create__wrapper{
  display: flex;
  justify-content: space-between;
  box-shadow: 0px 4.8px 14.4px rgb(0 0 0 / 18%);
  border-radius: 4px;
  height: 100%;
  margin-top: 8px !important;
}

.pill-106, .pill-125, .pill-152, .pill-179 {
  background-color: #F15725;
  padding: 0;
  border: none;
}

.pill-106:hover, .pill-125:hover, .pill-152:hover, .pill-179:hover {
  background-color: crimson;
}

.thumb-126, .thumb-107, .thumb-180, .thumb-153 {
  background-color: rgb(255, 255, 255);
  width: 22px;
  height: 22px;
  box-shadow: 0px 4.8px 14.4px rgb(0 0 0 / 18%);
}

.thumb-126:hover, .thumb-107:hover, .thumb-180:hover, .thumb-153:hover, .ms-Toggle-thumb {
  background-color: rgb(255, 255, 255);
}

.selection__box {
  border: 1px solid #ccc;
  border-radius: 4px;
  height: 20rem;
  width: 250px;
  overflow-y: auto;
}
.selection__box__ACD {
  border: 1px solid #ccc;
  border-radius: 4px;
  height: 20rem;
  width: 400px;
  overflow-y: auto;
}

.box__row {
  list-style: none;
  padding: 0;
  margin: 0;
}

.MuiListItem-button:hover {
  background-color: var(--primary) !important;
}

.MuiCheckbox-colorSecondary.Mui-checked {
  color: var(--primary) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Modules/CodeMapping/component/CreateCodeMapping/CreateCodeMapping.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,6CAA6C;EAC7C,kBAAkB;EAClB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,6CAA6C;EAC7C,kBAAkB;EAClB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,gCAAgC;AAClC","sourcesContent":[".__create__conteiner {\n  display: block;\n  font-size: 1.8rem;\n  height: 100vh;\n}\n\n.create__row {\n  box-shadow: 0px 4.8px 14.4px rgb(0 0 0 / 18%);\n  border-radius: 4px;\n  padding: 0.5rem 1rem 1rem 1rem;\n  height: auto;\n}\n\n.create__wrapper{\n  display: flex;\n  justify-content: space-between;\n  box-shadow: 0px 4.8px 14.4px rgb(0 0 0 / 18%);\n  border-radius: 4px;\n  height: 100%;\n  margin-top: 8px !important;\n}\n\n.pill-106, .pill-125, .pill-152, .pill-179 {\n  background-color: #F15725;\n  padding: 0;\n  border: none;\n}\n\n.pill-106:hover, .pill-125:hover, .pill-152:hover, .pill-179:hover {\n  background-color: crimson;\n}\n\n.thumb-126, .thumb-107, .thumb-180, .thumb-153 {\n  background-color: rgb(255, 255, 255);\n  width: 22px;\n  height: 22px;\n  box-shadow: 0px 4.8px 14.4px rgb(0 0 0 / 18%);\n}\n\n.thumb-126:hover, .thumb-107:hover, .thumb-180:hover, .thumb-153:hover, .ms-Toggle-thumb {\n  background-color: rgb(255, 255, 255);\n}\n\n.selection__box {\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  height: 20rem;\n  width: 250px;\n  overflow-y: auto;\n}\n.selection__box__ACD {\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  height: 20rem;\n  width: 400px;\n  overflow-y: auto;\n}\n\n.box__row {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.MuiListItem-button:hover {\n  background-color: var(--primary) !important;\n}\n\n.MuiCheckbox-colorSecondary.Mui-checked {\n  color: var(--primary) !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
